import { useEffect, useState } from 'react'

// カード一覧の列数を、ビューポートではなくグリッド自身の実測幅(ResizeObserver)から決める。
// サイドバー+左Navbarの分だけ実際に使える幅が変わるため。最大3列、狭くなると2列→1列。
// 案件一覧(PositionList)と人材一覧(UserList)で共用する。
export const DEFAULT_BREAKPOINTS = [
  { minWidth: 960, cols: 3 },
  { minWidth: 640, cols: 2 },
  { minWidth: 0, cols: 1 },
]

export default function useColumnCount(ref, breakpoints = DEFAULT_BREAKPOINTS) {
  const [cols, setCols] = useState(1)

  useEffect(() => {
    const el = ref.current
    if (!el) return undefined

    const observer = new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width
      const match = breakpoints.find((bp) => width >= bp.minWidth)
      setCols(match.cols)
    })
    observer.observe(el)
    return () => observer.disconnect()
  }, [ref, breakpoints])

  return cols
}
